(function () {
    if (!document.querySelector('#brandCustomSelect')) return;

    const brandCustomSelect = document.getElementById('brandCustomSelect');
    const brandSelectOptions = document.getElementById('brandSelectOptions');
    const modelCustomSelect = document.getElementById('modelCustomSelect');
    const modelSelectOptions = document.getElementById('modelSelectOptions');
    const bodyTypeCustomSelect = document.getElementById('bodyTypeCustomSelect');
    const bodyTypeSelectOptions = document.getElementById('bodyTypeSelectOptions');
    const yearsCustomSelect = document.getElementById('yearsCustomSelect');
    const yearsSelectOptions = document.getElementById('yearsSelectOptions');
    const clearFilters = document.getElementById('clearFilters');
    const searchButton = document.getElementById('searchButtonJson');
    const brandsModelsJsonUrl = document.querySelector('.filter-container-json').dataset.json;

    let localJson;

    // Загружаем данные для брендов и моделей
    fetch(brandsModelsJsonUrl)
        .then(response => response.json())
        .then(data => {
            localJson = data;
            populateBrandDropdown(localJson);
        })
        .catch(error => console.error('Error loading JSON:', error));

    async function fetchAllCollectionProducts(collectionUrl) {
        let allProducts = [];
        let currentPage = 1;
        let totalPages = 1;

        const fetchPage = async (page) => {
            const url = `${collectionUrl}?page=${page}&view=json`;
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            return data;
        };

        try {
            // Загружаем первую страницу
            const firstPageData = await fetchPage(1);
            allProducts = allProducts.concat(firstPageData.products);
            totalPages = Math.ceil(firstPageData.total_products / firstPageData.products.length);

            // Загружаем все оставшиеся страницы
            for (let page = 2; page <= totalPages; page++) {
                const data = await fetchPage(page);
                allProducts = allProducts.concat(data.products);
            }

            return allProducts;
        } catch (error) {
            console.error('Error fetching collection products:', error);
        }
    }

    function populateBrandDropdown(data) {
        brandSelectOptions.innerHTML = '';
        Object.keys(data).forEach(brand => {
            const div = document.createElement('div');
            div.textContent = brand;
            div.addEventListener('click', function() {
                selectOption(this, brandCustomSelect, brandSelectOptions);
                resetModelSelect();
                populateModelDropdown(data[brand].models);
                enableModelSelect();
            });
            brandSelectOptions.appendChild(div);
        });
    }

    function populateModelDropdown(models) {
        modelSelectOptions.innerHTML = '';
        models.forEach(model => {
            const div = document.createElement('div');
            div.textContent = model.name;
            div.dataset.url = model.url;
            div.addEventListener('click', function() {
                selectOption(this, modelCustomSelect, modelSelectOptions);
                enableFilters();  // Делаем фильтры активными после выбора модели
                fetchAndPopulateFilters(model.url); // Загружаем и заполняем фильтры после выбора модели
            });
            modelSelectOptions.appendChild(div);
        });
    }

    // Функция для загрузки продуктов с пагинацией и заполнения фильтров
    async function fetchAndPopulateFilters(collectionUrl) {
        let allProducts = [];
        let currentPage = 1;
        let totalPages = 1;

        const fetchPage = async (page) => {
            const url = `${collectionUrl}?page=${page}&view=json`;
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            console.log(data)
            return data;
        };

        try {
            // Загружаем первую страницу
            const firstPageData = await fetchPage(1);
            allProducts = allProducts.concat(firstPageData.products);
            totalPages = Math.ceil(firstPageData.total_products / firstPageData.products.length);

            // Загружаем все оставшиеся страницы
            for (let page = 2; page <= totalPages; page++) {
                const data = await fetchPage(page);
                allProducts = allProducts.concat(data.products);
            }

            let bodyTypes = new Set();
            let years = new Set();

            allProducts.forEach(product => {
                if (product.body_type) {
                    bodyTypes.add(product.body_type);
                }
                if (product.years) {
                    years.add(product.years);
                }
            });

            populateBodyTypeDropdown([...bodyTypes]);
            populateYearsDropdown([...years]);
        } catch (error) {
            console.error('Error fetching collection products:', error);
        }
    }

    function populateBodyTypeDropdown(bodyTypes) {
        bodyTypeSelectOptions.innerHTML = '';
        bodyTypes.forEach(bodyType => {
            const div = document.createElement('div');
            div.textContent = bodyType;
            div.addEventListener('click', function() {
                selectOption(this, bodyTypeCustomSelect, bodyTypeSelectOptions);
            });
            bodyTypeSelectOptions.appendChild(div);
        });
    }

    function populateYearsDropdown(years) {
        yearsSelectOptions.innerHTML = '';
        years.sort((a, b) => {
            const startYearA = parseInt(a.split('-')[0], 10);
            const startYearB = parseInt(b.split('-')[0], 10);
            return startYearB - startYearA; // Сортировка по убыванию начального года
        }).forEach(year => {
            const div = document.createElement('div');
            div.textContent = year;
            div.addEventListener('click', function() {
                selectOption(this, yearsCustomSelect, yearsSelectOptions);
            });
            yearsSelectOptions.appendChild(div);
        });
    }

    function selectOption(element, selectWrapper, selectOptions) {
        const selected = selectWrapper.querySelector('.select-selected');
        selected.value = element.textContent;
        selected.dataset.url = element.dataset.url;
        selectOptions.classList.add('select-hide');
        selectWrapper.classList.add('selected');
        checkIfSearchEnabled();
        closeAllSelects();
    }

    function buildUrl() {
        const modelElement = modelCustomSelect.querySelector('.select-selected');
        const modelUrl = modelElement.dataset.url;
        const urlParams = new URLSearchParams();

        const bodyType = bodyTypeCustomSelect.querySelector('.select-selected').value;
        if (bodyType) {
            urlParams.set('filter.p.m.custom.filter_body_type', bodyType);
        }

        const years = yearsCustomSelect.querySelector('.select-selected').value;
        if (years) {
            urlParams.set('filter.p.m.custom.filter_years', years);
        }

        const queryString = urlParams.toString();
        return modelUrl + (queryString ? '?' + queryString : '');
    }

    function resetModelSelect() {
        modelCustomSelect.querySelector('.select-selected').value = '';
        modelSelectOptions.innerHTML = '';
        modelCustomSelect.classList.remove('selected');
    }

    function enableModelSelect() {
        const modelInput = modelCustomSelect.querySelector('.select-selected');
        modelInput.classList.remove('disabled');
        modelInput.removeAttribute('disabled');
    }

    function enableFilters() {
        const bodyTypeInput = bodyTypeCustomSelect.querySelector('.select-selected');
        const yearsInput = yearsCustomSelect.querySelector('.select-selected');
        bodyTypeInput.classList.remove('disabled');
        bodyTypeInput.removeAttribute('disabled');
        bodyTypeInput.value = ''
        yearsInput.value = ''
        yearsInput.classList.remove('disabled');
        yearsInput.removeAttribute('disabled');
    }

    function closeAllSelects() {
        const selectItems = document.querySelectorAll('.select-items');
        selectItems.forEach(item => item.classList.add('select-hide'));
    }

    document.getElementById('brandInput').addEventListener('click', function() {
        toggleSelectOptions(brandSelectOptions);
    });

    document.getElementById('modelInput').addEventListener('click', function() {
        toggleSelectOptions(modelSelectOptions);
    });

    document.getElementById('bodyTypeInput').addEventListener('click', function() {
        toggleSelectOptions(bodyTypeSelectOptions);
    });

    document.getElementById('yearsInput').addEventListener('click', function() {
        toggleSelectOptions(yearsSelectOptions);
    });

    function toggleSelectOptions(selectOptions) {
        selectOptions.classList.toggle('select-hide');
    }

    document.addEventListener('click', function(event) {
        if (!event.target.closest('.custom-select-wrapper')) {
            closeAllSelects();
        }
    });

    clearFilters.addEventListener('click', function() {
        brandCustomSelect.querySelector('.select-selected').value = '';
        modelCustomSelect.querySelector('.select-selected').value = '';
        bodyTypeCustomSelect.querySelector('.select-selected').value = '';
        yearsCustomSelect.querySelector('.select-selected').value = '';
        closeAllSelects();
    });

    searchButton.addEventListener('click', function() {
        const url = buildUrl();
        console.log(url)
        window.location.href = url;
    });

    function checkIfSearchEnabled() {
        const selectedBrand = brandCustomSelect.querySelector('.select-selected').value;
        const selectedModel = modelCustomSelect.querySelector('.select-selected').value;

        
        if (selectedBrand !== '' && selectedModel !== '') {
            searchButton.disabled = false;   
        } else {
            searchButton.disabled = true;    
        }
    }

    document.getElementById('brandInput').addEventListener('input', function() {
        filterSelectOptions('brandInput', 'brandSelectOptions');
    });

    document.getElementById('modelInput').addEventListener('input', function() {
        filterSelectOptions('modelInput', 'modelSelectOptions');
    });

    document.getElementById('bodyTypeInput').addEventListener('input', function() {
        filterSelectOptions('bodyTypeInput', 'bodyTypeSelectOptions');
    });

    document.getElementById('yearsInput').addEventListener('input', function() {
        filterSelectOptions('yearsInput', 'yearsSelectOptions');
    });

    function filterSelectOptions(inputId, optionsId) {
        const input = document.getElementById(inputId);
        let filter = input.value.toLowerCase();
    
        // Замена буквы 's' на возможные эквиваленты, включая 'š'
        filter = filter.replace(/s/g, '[sš]');
    
        const divs = document.getElementById(optionsId).getElementsByTagName('div');
    
        for (let i = 0; i < divs.length; i++) {
            const txtValue = divs[i].textContent || divs[i].innerText;
    
            // Создаем регулярное выражение для фильтрации
            const regex = new RegExp(filter, 'i');
            if (regex.test(txtValue)) {
                divs[i].style.display = "";
            } else {
                divs[i].style.display = "none";
            }
        }
    
        if (inputId === "brandInput" && input.value.trim() === '') {
            document.getElementById('modelInput').setAttribute('disabled', true);
        }
    }    
})();
